import { Page_Pagebuilder_Blocks_Table } from '@/graphql/generated/graphql';
import { m } from 'motion/react';
import { Fragment } from 'react/jsx-runtime';
import { containerVariants, viewPort } from 'utils/framer';
import { getContainerClass } from 'utils/helpers';
import Wysiwyg from '../components/dom-parser';

const TableBlock = ({
  blockId,
  containerWidth,
  cols,
  rows,
}: Page_Pagebuilder_Blocks_Table) => {
  if (!cols || cols.length === 0) return null;

  return (
    <m.section
      initial="hidden"
      whileInView="visible"
      viewport={viewPort}
      variants={containerVariants}
      id={blockId ?? undefined}
      className="w-full my-14 lg:my-24"
    >
      <div
        className={`w-full max-lg:overflow-x-scroll ${getContainerClass(containerWidth)}`}
      >
        <table className="editor-table">
          <thead>
            <tr className="align-baseline bg-neutral-100">
              <th className="max-lg:hidden min-w-52 p-4 border border-neutral-300"></th>
              {cols.map((col, i) => (
                <th
                  key={i}
                  className="p-4 border border-neutral-300 text-left font-normal"
                >
                  <Wysiwyg>{col.colLabel}</Wysiwyg>
                </th>
              ))}
            </tr>
          </thead>
          <tbody>
            {rows.map((row, i) => (
              <Fragment key={i}>
                <tr className="lg:hidden">
                  <th
                    colSpan={rows.length}
                    className="lg:min-w-52 p-4 bg-neutral-100 border border-neutral-300"
                  >
                    {row.rowLabel}
                  </th>
                </tr>
                <tr
                  className={`bg-white ${Math.abs(i % 2) == 1 ? 'lg:bg-white' : 'lg:bg-neutral-100'}`}
                >
                  <th className="max-lg:hidden min-w-52 p-4 border border-neutral-300">
                    {row.rowLabel}
                  </th>
                  {row.rowCells.map((cell, j) => (
                    <td
                      key={j}
                      className="lg:min-w-52 p-4 border border-neutral-300 text-center"
                    >
                      <Wysiwyg>{cell.cellContent}</Wysiwyg>
                    </td>
                  ))}
                </tr>
              </Fragment>
            ))}
          </tbody>
        </table>
      </div>
    </m.section>
  );
};

export default TableBlock;
